import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataService, DefaultDataServiceConfig, HttpUrlGenerator, QueryParams } from '@ngrx/data';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { TypeOfLeave } from 'src/app/shared/_models/type-of-leave.model';

@Injectable({
  providedIn: 'root'
})

export class TypeOfLeaveDataService extends DefaultDataService<TypeOfLeave> {
  constructor(http: HttpClient, httpUrlGenerator: HttpUrlGenerator, config: DefaultDataServiceConfig) {
    super('type-of-leaves', http, httpUrlGenerator, config);
  }

  // getWithQuery(queryParams: QueryParams | string): Observable<TypeOfLeave[]> {
  //   return super.getWithQuery(queryParams).pipe(map((res) => {
  //     const data = res['content'];
  //     return data as any;
  //   }));
  // }
}
